import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { Locale } from '@/types'

  // Config
  import { links, Links } from '@/config/links'

  // Components
  import PageSection from '../UI/PageSection.vue'
  import AccordionItem from './AccordionItem.vue'

  // Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  import useScreenSize from '@/composables/useScreenSize'

  // Services
  import YoonlyService from '@/services/YoonlyService'

  // Methods
  
export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSection',
  setup(__props) {

  // Types
  const store = useStore()

  // Translations
  const { t } = useI18n()

  // Composables
  const handleOpen = (key: keyof Links, target = '_blank'): void => {
    const link: string = getLink(key)
    window.open(link, target)
  }

  const logout = () => {
    store.dispatch('auth/logout')
  }

  // Computed
  const { isMobile } = useScreenSize()
  const isYoonly = new YoonlyService().isYoonly

  const getLink = (key: keyof Links): string => {
    const locale = store.getters.getLocale as Exclude<Locale, 'en-US'>

    const localeLinks: Links = links[isYoonly ? "yoonly" : locale]
    if (!localeLinks) throw new Error('invalid locale in getLink')
    return localeLinks[key] || ''
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageSection, {
    title: _unref(t)('profile.infoTitle')
  }, {
    default: _withCtx(() => [
      _createVNode(AccordionItem, {
        text: _unref(t)('profile.contactUs'),
        onClick: _cache[0] || (_cache[0] = () => handleOpen('contact'))
      }, null, 8, ["text"]),
      _createVNode(AccordionItem, {
        text: _unref(t)('profile.FAQ'),
        onClick: _cache[1] || (_cache[1] = () => handleOpen('faq'))
      }, null, 8, ["text"]),
      _createVNode(AccordionItem, {
        text: _unref(t)('profile.legal'),
        onClick: _cache[2] || (_cache[2] = () => handleOpen('legal'))
      }, null, 8, ["text"]),
      _createVNode(AccordionItem, {
        text: _unref(t)('documents.claimTitle'),
        onClick: _cache[3] || (_cache[3] = () => handleOpen('neat'))
      }, null, 8, ["text"]),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(AccordionItem, {
            key: 0,
            class: "d-md-none",
            text: _unref(t)('navbar.logout'),
            onClick: logout,
            displayIcon: false
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})